import React, { useEffect, useRef } from "react";
import { useDockSlots } from "./DockSlotsContext";

/**
 * A placeholder where the docked visualizer should appear. The single
 * <VisualizerDockShell/> measures this element and overlays the visualizer on
 * top of it (fixed positioning), so the visualizer is never remounted when the
 * route changes — it just animates from one slot to another.
 */
export default function DockSlot({ name, className = "" }) {
  const ref = useRef(null);
  const { registerSlot } = useDockSlots();

  useEffect(() => {
    registerSlot(name, ref.current);
    return () => registerSlot(name, null);
  }, [name, registerSlot]);

  return <div data-name={name}
              ref={ref}
              className={className}
              style={{ width: "100%", height: "100%" }} />;
}
